/**
 * Dynamic Elevator portal design tokens (product spec).
 * Blue = primary UI. Brand red used sparingly (logo, critical alerts).
 */

export const colors = {
	primary: {
		50: "#EFF6FF",
		100: "#DBEAFE",
		200: "#BFDBFE",
		300: "#93C5FD",
		400: "#60A5FA",
		500: "#2563EB",
		600: "#1D4ED8",
		700: "#1E40AF",
		800: "#1E3A8A",
		900: "#172554",
	},
	success: {
		50: "#F0FDF4",
		100: "#DCFCE7",
		200: "#BBF7D0",
		300: "#86EFAC",
		400: "#4ADE80",
		500: "#22C55E",
		600: "#16A34A",
		700: "#15803D",
		800: "#166534",
		900: "#14532D",
	},
	warning: {
		50: "#FFFBEB",
		100: "#FEF3C7",
		200: "#FDE68A",
		300: "#FCD34D",
		400: "#FBBF24",
		500: "#F59E0B",
		600: "#D97706",
		700: "#B45309",
		800: "#92400E",
		900: "#78350F",
	},
	danger: {
		50: "#FEF2F2",
		100: "#FEE2E2",
		200: "#FECACA",
		300: "#FCA5A5",
		400: "#F87171",
		500: "#EF4444",
		600: "#DC2626",
		700: "#B91C1C",
		800: "#991B1B",
		900: "#7F1D1D",
	},
	info: {
		50: "#F0F9FF",
		100: "#E0F2FE",
		200: "#BAE6FD",
		300: "#7DD3FC",
		400: "#38BDF8",
		500: "#0EA5E9",
		600: "#0284C7",
		700: "#0369A1",
		800: "#075985",
		900: "#0C4A6E",
	},
	neutral: {
		50: "#F8FAFC",
		100: "#F1F5F9",
		200: "#E2E8F0",
		300: "#CBD5E1",
		400: "#94A3B8",
		500: "#64748B",
		600: "#475569",
		700: "#334155",
		800: "#1E293B",
		900: "#0F172A",
	},
	brand: {
		accent: "#C8102E",
	},
	sidebar: {
		background: "#0F172A",
		hover: "#1E293B",
		active: "#1D4ED8",
	},
	background: {
		nav: "#0F172A",
		body: "#F8FAFC",
		surface: "#FFFFFF",
		level1: "#F8FAFC",
		level2: "#F1F5F9",
	},
	text: {
		nav: "#FFFFFF",
		navMuted: "#94A3B8",
		primary: "#0F172A",
		secondary: "#64748B",
		tertiary: "#94A3B8",
	},
	border: {
		default: "#E2E8F0",
		strong: "#CBD5E1",
		dashed: "#E2E8F0",
	},
	button: {
		primary: {
			background: "#2563EB",
			hover: "#1D4ED8",
			text: "#FFFFFF",
		},
		secondary: {
			background: "#FFFFFF",
			border: "#CBD5E1",
			text: "#334155",
		},
		success: {
			background: "#16A34A",
			hover: "#15803D",
			text: "#FFFFFF",
		},
	},
	table: {
		header: "#F1F5F9",
		rowHover: "#EFF6FF",
		selectedRow: "#DBEAFE",
		divider: "#E2E8F0",
	},
	buildingList: {
		background: "#FFFFFF",
		hover: "#F8FAFC",
		selected: "#2563EB",
		selectedText: "#FFFFFF",
		divider: "#E2E8F0",
		badgeBackground: "#DBEAFE",
		badgeText: "#1D4ED8",
	},
} as const;

export const radius = {
	xs: "0",
	sm: "0",
	md: "0",
	lg: "0",
	xl: "0",
} as const;

export const shadow = {
	xs: "0 1px 2px rgba(15, 23, 42, 0.05)",
	sm: "0 1px 3px rgba(15, 23, 42, 0.08)",
	md: "0 2px 8px rgba(15, 23, 42, 0.1)",
	lg: "0 4px 16px rgba(15, 23, 42, 0.12)",
	xl: "0 8px 24px rgba(15, 23, 42, 0.14)",
} as const;